import React, { useState } from 'react'
import { Checkbox, Select, Button, Space } from 'antd'
import { SmallSpinner } from 'portal/lib/primitives'
import PropTypes from 'prop-types'
import _ from 'lodash'

function dropdownRender(
  menu,
  name,
  state,
  projectId,
  selected,
  handleOk,
  handleReset
) {
  if (_.get(state.options, [projectId, name, 'loading'], true)) {
    return (
      <div style={{ textAlign: 'center' }}>
        <SmallSpinner />
      </div>
    )
  }
  if (state.options[projectId][name].error !== null) {
    return <div> An error occured while loading options.</div>
  }
  return (
    <>
      {menu}
      <div style={{ padding: 8, borderTop: '1px solid #f0f0f0' }}>
        <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            size="small"
            type="text"
            disabled={selected.length === 0}
            onClick={handleReset}
          >
            Reset
          </Button>
          <Button type="primary" size="small" onClick={handleOk}>
            OK
          </Button>
        </Space>
      </div>
    </>
  )
}

export function RecordsSelect(
  name,
  state,
  fetchOptions,
  filters,
  updateFilter,
  projectId,
  tableId
) {
  const [selected, setSelected] = useState(filters?.[name] || [])

  // Pre-load options for assignedTo filter, check the number of options is greater than 1 (as there is always an 'Unassigned' option)
  if (name === 'assignedTo') {
    if (_.get(state.options, [projectId, name]) === undefined) {
      fetchOptions(name)
    } else if (_.get(state.options, [projectId, name, 'options'])?.length < 2) {
      setTimeout(() => {
        fetchOptions(name)
      }, 0)
    }
  }

  const dropdownOptions = []

  Array(..._.get(state.options, [projectId, name, 'options'], []))
    .filter(option => option && /\S/.test(option))
    .sort((a, b) =>
      a.label
        ? a.label.localeCompare(b.label, 'en', { sensitivity: 'base' })
        : a.localeCompare(b, 'en', { sensitivity: 'base' })
    )
    // Options can be an array of strings or objects with 'key' & 'label' properties
    .map(option =>
      dropdownOptions.push({
        key: option.key || option,
        value: option.key || option,
        label: option.label || option
      })
    )

  const classNameForWidth =
    name === 'items[].knownContainerType'
      ? 'knownContainerType'
      : name === 'items[].wasteCode'
        ? 'wasteCode'
        : name === 'products[].productGroupName'
          ? 'productGroupNames'
          : name

  const width =
    document.querySelector(`th.${classNameForWidth}`)?.offsetWidth || 200

  const handleReset = () => {
    setSelected([]) // clear temporary selection
  }

  const handleOk = () => {
    // Update filter with the current selection (which will cause a reload of the table data)
    updateFilter(name, selected)
  }

  return (
    <div style={{ width: width }}>
      <Select
        className="records-filter-select"
        name={name}
        data-testid={`${name}Filter`}
        autoClearSearchValue={false}
        maxTagCount="responsive"
        popupMatchSelectWidth={false}
        mode="multiple"
        showSearch
        allowClear
        style={{ width: '100%' }}
        options={dropdownOptions}
        optionRender={option => (
          <Checkbox checked={selected.includes(option.value)}>
            {option.label}
          </Checkbox>
        )}
        menuItemSelectedIcon={null}
        popupRender={menu =>
          dropdownRender(
            menu,
            name,
            state,
            projectId,
            selected,
            handleOk,
            handleReset
          )
        }
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onOpenChange={isVisible => {
          if (
            isVisible &&
            _.get(state.options, [projectId, name]) === undefined
          ) {
            fetchOptions(name)
          }
          if (!isVisible) {
            updateFilter(name, selected) // Ensure filter is updated when dropdown is closed, even if no change was made to the selection
          }
        }}
        getPopupContainer={() => document.getElementById(tableId)}
        value={selected}
        onChange={setSelected}
      />
    </div>
  )
}

RecordsSelect.propTypes = {
  name: PropTypes.string,
  state: PropTypes.object,
  fetchOptions: PropTypes.func,
  filters: PropTypes.object,
  updateFilter: PropTypes.func
}
